"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var preact_1 = require("preact");
var App_1 = require("./App");
(0, preact_1.render)((0, jsx_runtime_1.jsx)(App_1.default, {}), document.body);
